import formatData from './formatData';

export default {

    mixins: [
        formatData
    ],

    methods: {
        /**
         * Formatea el objeto `this.data` y setea el resultado en `this.formattedData`.
         *
         * Por defecto copia la misma estructura de data. Pero se pueden definir reglas específicas para cada campo.
         * Para ello se debe incluir el campo en el objeto `this.formatDataRules`, con un array donde:
         * - El último elemento será la función a ejecutar, que tendrá como parámetros el valor del campo
         * y el objeto formateado hasta el momento.
         * - Opcionalmente se puede renombrar el campo pasando un string
         *
         * ej:  'field1': [ 'field_1', (value) => value ]
         *
         */
        formatData() {
            const data = this.data;
            if (!data) {
                return;
            }
            const rules = this.formatDataRules();
            this.formattedData = data.map(x => {
                const f = Object.keys(x).reduce((acc, key) => {
                    if (rules[key]) {
                        const rule = rules[key].pop();
                        let field = key;
                        if (rules[key].length > 0) {
                            field = rules[key].pop();
                        }
                        acc[field] = rule(x[key], acc);
                    } else {
                        acc[key] = x[key];
                    }
                    return acc;
                }, {});
                return f;
            });
        }
    }
};
